import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import UserService from '../../services/UserService'; // Assumes you have a UserService for API calls
import { Link } from 'react-router-dom';

const UserList = () => {
  const [users, setUsers] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [usersPerPage] = useState(5);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const data = await UserService.getAll();
      setUsers(data);
    } catch (error) {
      console.error('Error fetching users:', error);
    }
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: 'Do you really want to delete this user?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel!',
    });

    if (result.isConfirmed) {
      try {
        await UserService.delete(id);
        Swal.fire('Deleted!', 'User deleted successfully.', 'success');
        fetchUsers(); // Refresh the list after deletion
      } catch (error) {
        console.error('Error deleting user:', error);
        Swal.fire('Error!', 'An error occurred while deleting the user.', 'error');
      }
    }
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };

  const filteredUsers = users.filter((user) =>
    user.first_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    user.last_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    user.email.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const indexOfLastUser = currentPage * usersPerPage;
  const indexOfFirstUser = indexOfLastUser - usersPerPage;
  const currentUsers = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);

  const totalPages = Math.ceil(filteredUsers.length / usersPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div className="content-wrapper">
      <div className="row">
        <div className="col-md-10 mx-auto">
          <div className="card shadow-lg border-0 rounded-lg">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center mb-4">
                <h3 className="card-title text-primary">
                  <i className="ti-user mr-2"></i> User Management
                </h3>
                <Link to="/users/create" className="btn btn-primary btn-sm">
                  <i className="ti-plus menu-icon"></i> Add User
                </Link>
              </div>

              <p className="card-description text-muted">View, search, and manage system users.</p>

              {/* Search Bar */}
              <div className="mb-4">
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Search users by name or email..."
                  value={searchQuery}
                  onChange={handleSearch}
                />
              </div>

              {/* User List */}
              {currentUsers.length > 0 ? (
                <ul className="list-group">
                  {currentUsers.map((user) => (
                    <li
                      key={user.id}
                      className="list-group-item d-flex justify-content-between align-items-center bg-light mb-2"
                      style={{ borderRadius: '8px', fontSize: '0.9rem' }}
                    >
                      <div>
                        <strong>{user.first_name} {user.last_name}</strong>
                        <p className="mb-1 text-muted small">
                          <i className="ti-email mr-1"></i> {user.email}
                        </p>
                        <p className="mb-0 text-muted small d-flex">
                          <span className="mr-3">
                            <i className="ti-briefcase mr-1"></i> {user.role?.name || 'N/A'}
                          </span>
                          <span className="mr-3">
                            <i className="ti-home mr-1"></i> {user.department?.name || 'N/A'}
                          </span>
                          <span>
                            <i className="ti-world mr-1"></i> {user.entity?.name || 'N/A'}
                          </span>
                        </p>
                      </div>
                      <div>
                        <Link to={`/users/edit/${user.id}`} className="btn btn-sm btn-primary mr-2">
                          <i className="ti-pencil-alt"></i> Edit
                        </Link>
                        <button
                          className="btn btn-sm btn-danger"
                          onClick={() => handleDelete(user.id)}
                        >
                          <i className="ti-trash"></i> Delete
                        </button>
                      </div>
                    </li>
                  ))}
                </ul>
              ) : (
                <p className="text-muted text-center">No users found.</p>
              )}

              {/* Pagination Controls */}
              <nav>
                <ul className="pagination justify-content-center mt-4">
                  {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                    <li
                      key={page}
                      className={`page-item ${page === currentPage ? 'active' : ''}`}
                    >
                      <button onClick={() => paginate(page)} className="page-link">
                        {page}
                      </button>
                    </li>
                  ))}
                </ul>
              </nav>
            </div>

            <div className="card-footer text-muted">
              Showing {currentUsers.length} of {filteredUsers.length} users
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserList;
